import { AppState } from '../index';
import { PrescriptionItemInterface } from '../../interfaces/prescription';
import ItemsStatusInterface from '../../interfaces/itemsStatus';
import { ItemInterface } from '../../components/application/Dispensation/Table/types';


export const getTransformedPrescriptionItems = (
  state: AppState,
): ItemInterface[] => {
  const { prescription, itemsStatus } = state.prescription;

  return prescription.items.map((item: PrescriptionItemInterface) => {

    const statusInfo = itemsStatus?.find(
      (status: ItemsStatusInterface) => status.item_id === item.id,
    );

    return {
      id: item.id,
      title: item.name,
      quantity: item.quantity,
      unit: item.unit,
      description: item.dosage,
      checked: item.checked,
      selectedQuantity: item.selectedQuantity || 0,
      blockedLabel: item.blocked ? 'bloqueio temporário' : '',
      dispensedLabel: item.dispensed ? 'dispensado' : '',
      compositions: item.compositions,
      recipe: item.recipe,
      cid: item.cid,
      prescribedQuantity: statusInfo?.prescribed_quantity,
      dispensedQuantity: statusInfo?.dispensed_quantity,
      dispensationStatus: statusInfo?.dispensation_status,
      isPartialDispensationEnabled: item.isPartialDispensationEnabled,
      availableQuantity: statusInfo?.available_quantity,
    };
  });
};
